import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const EditBanner = () => {
 const [BannerImage, setBannerImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();


  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("ban_id", id);
    if (BannerImage) formData.append("banner_img", BannerImage);

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_banner_image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

     if (response.data.success === "1") {
      toast.info(response.data.message || "Banner updated successfully");
      navigate("/Master/Banner");
    } else {
      toast.error(response.data.message || "Failed to update Banner");
    }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)", // backdrop
        paddingRight: 18,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header table-custom justify-content-center">
              <h5 className="modal-title text-white">Edit Banner</h5>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  Image{" "}
                  <span className="text-danger">
                    (Image must be at least 90x100%)
                  </span>
                </label>
                <input
                  type="file"
                  id="banner_img"
                  className="form-control"
                  onChange={(e) => setBannerImage(e.target.files[0])}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer d-flex justify-content-end">
              <Link to="/Master/Banner">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-success me-2">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
